import { useState } from 'react';
import {
  TextField,
  Button,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import axiosInstance from '../../helpers/Axios';
import StageImagePicker from '../StageImagePicker';

type TeamMember = {
  teamId: number;
  firstName: string;
  lastName: string;
  imageUrl?: string;
  description: string;
};

type Props = {
  member: TeamMember;
  onClose: () => void;
  onSaved: () => void;
};

const TeamForm = ({ member, onClose, onSaved }: Props) => {
  const [form, setForm] = useState<TeamMember>(member);

  const handleChange = (field: keyof TeamMember, value: any) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (form.teamId === 0) {
      // ➕ création
      await axiosInstance.post('/team', form);
    } else {
      // ✏️ mise à jour
      await axiosInstance.put(`/team/${form.teamId}`, form);
    }

    onSaved();
    onClose();
  };

  return (
    <Paper sx={{ p: 3, mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {form.teamId === 0 ? 'Ajouter une personne' : 'Modifier la personne'}
      </Typography>

      <Stack spacing={2}>
        <TextField
          label="Prénom"
          value={form.firstName}
          onChange={e => handleChange('firstName', e.target.value)}
        />

        <TextField
          label="Nom"
          value={form.lastName}
          onChange={e => handleChange('lastName', e.target.value)}
        />

        {/* Image picker réutilisé ✅ */}
        <StageImagePicker
          label="Photo de la personne"
          value={form.imageUrl ?? null}
          onChange={url => handleChange('imageUrl', url)}
          folder="team"
        />

        <TextField
          label="Description"
          multiline
          minRows={5}
          value={form.description}
          onChange={e => handleChange('description', e.target.value)}
          helperText="Tu peux utiliser plusieurs paragraphes (laisser une ligne vide)"
        />

        <Stack direction="row" spacing={2}>
          <Button variant="contained" onClick={handleSubmit}>
            Enregistrer
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Annuler
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default TeamForm;